(function () {
    'use strict';

    angular
        .module('partners')
        .controller('ManagePlatformRentalFormController', ManagePlatformRentalFormController);

    ManagePlatformRentalFormController.$inject = ['$state', '$stateParams', 'PlatformRentalService', 'virtualFairs', 'id', 'toastr'];

    function ManagePlatformRentalFormController($state, $stateParams, PlatformRentalService, virtualFairs, id, toastr) {
        var vm = this;
        vm.id = false;
        vm.user = {
            id: null,
            name: null,
            email: null,
            virtualfairs: [],
            password: null,
            password_confirmation: null,
        };
        vm.edit = edit;
        vm.submit = submit;
        vm.activate = activate;
        vm.formErrors = [];

        function activate() {
            vm.virtualFairs = virtualFairs;
            if ($stateParams.hasOwnProperty('id')) {
                vm.edit($stateParams.id);
            }
        }

        function submit() {

            if(id) {
                PlatformRentalService.updatePlatformRental(id, vm.user)
                .then(function(response) {
                    if (response.errors) {
                        vm.formErrors = response.errors;
                    } else {
                        toastr.success("Platform Rental successfull updated");
                    }
                }).catch(function(err) {
                    toastr.error("Something went wrong. Please try again later")
                });
            } else {
                PlatformRentalService.storePlatformRental(vm.user)
                .then(function(response) {
                    if (response.errors) {
                        vm.formErrors = response.errors;
                    } else {
                        $state.go('root.virtualfair.reports.platformRental');
                    }
                }).catch(function(err) {
                    toastr.error("Something went wrong. Please try again later")
                });
            }
            
        }

        function edit(id) {
            PlatformRentalService.getPlatformRental(id)
                .then(function(response) {
                    vm.user = {
                        id: response.data.id,
                        name: response.data.name,
                        email: response.data.email,
                        virtualfairs: [],
                    };
                    if(response.data.virtualfairs) {
                        angular.forEach(response.data.virtualfairs, function(item) {
                            vm.user.virtualfairs.push(item.id);
                        });
                    }
                });
        }

        activate();
    }
})();
